import { Component, Inject, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from '@app/models/util/paginacao';
import { Peticao } from '@app/models/peticao';
import { PeticaoService } from '@app/services/peticao.service';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-peticao-lista',
  templateUrl: './peticao-lista.component.html',
  styleUrls: ['./peticao-lista.component.scss']
})
export class PeticaoListaComponent implements OnInit {

  lstPeticao: Peticao[];
  paginacao: Paginacao = new Paginacao();
  filtroDescricao = '';
  bsModalRef: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private peticaoService: PeticaoService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }


  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.peticaoService.obterPesquisa(descricao, pagina)
      .toPromise().then(data => {
        this.lstPeticao = data.Dados;
        this.paginacao.totalDeItens = data.Total;
      }, erro => {
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  deletar(peticao: Peticao) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente excluir a petição :' + peticao.Descricao;
    this.bsModalRef.content.confirmar = () => {
      this.peticaoService.deletar(peticao.Id).subscribe(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    };
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }
}
